// @ts-nocheck
export const TRAINING_SLUGS = {
  mvp: 'ai-mvp-training',
  opsAutomation: 'ai-ops-automation-training',
  knowledgeAssistant: 'ai-knowledge-assistant-training',
  analystCopilot: 'ai-analyst-copilot-training',
  nedOpportunity: 'ned-opportunity-training',
};

export const LEGACY_TRAINING_SLUG_ALIASES = {
  'one-week-ai-mvp-training': TRAINING_SLUGS.mvp,
  'one-week-ai-ops-automation-training': TRAINING_SLUGS.opsAutomation,
  'one-week-ai-knowledge-assistant-training': TRAINING_SLUGS.knowledgeAssistant,
  'one-week-ai-analyst-copilot-training': TRAINING_SLUGS.analystCopilot,
};

export function canonicalizeTrainingSlug(slug) {
  const normalized = String(slug || '').trim().toLowerCase();
  return LEGACY_TRAINING_SLUG_ALIASES[normalized] || normalized;
}

export function getLegacyTrainingSlugs(slug) {
  const canonicalSlug = canonicalizeTrainingSlug(slug);
  return Object.entries(LEGACY_TRAINING_SLUG_ALIASES)
    .filter(([, canonical]) => canonical === canonicalSlug)
    .map(([legacy]) => legacy);
}
